import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'

var shopIconCount = 0;

class ShopIcon extends PureComponent {

    componentDidMount() {

        if(!this._ref || ! this._ref.children) return;

        const {classes} = this.props;
        this._ref.children[0].classList.add(classes.path);
        this._ref.children[0].classList.add(`delay${shopIconCount++%4}`);
    }

    _setRef = (ref) => this._ref = ref;

    render() {
        const {className, width=16, height=16} = this.props;
        return <svg viewBox="0 0 14 13" width={`${width}px`} height={`${height}px`} className={className} ref={this._setRef}>
            <path fill="none" fillRule="evenodd" stroke="currentColor" d="M4.927 2.964a1.964 1.964 0 1 1 3.928 0c0 1.65-1.964 1.963-1.964 1.963v.786l5.891 5.498v.786H1v-.786l4.32-3.927"></path>
        </svg>
    }
}

export default injectSheet((theme) => ({
    path: {
        strokeDasharray: '50px',
        strokeDashoffset: '50px',
        animation: 'dash 5s linear infinite',
        '&.delay0': {},
        '&.delay1': {
            animationDelay: '500ms'
        },
        '&.delay2': {
            animationDelay: '1000ms'
        },
        '&.delay3': {
            animationDelay: '1500ms'
        },
    },
    '@keyframes dash': {
        '0%': {
            strokeDashoffset: '50px'
        },
        '15%': {
            strokeDashoffset: '0px'
        },
        '100%': {
            strokeDashoffset: '0px'
        },
    }
}))(ShopIcon)





// WEBPACK FOOTER //
// ./src/components/Widgets/ShopIcon.js